export const siteConfig = {
  brand: 'BPA Solutions',
  tagline: 'Smart Systems. Better Business.',
  privacyPolicyUrl: 'https://www.bpasolutions.au/privacy-policy'
};

export const assessmentConfig = {
  title: 'Timesheet-to-Invoice Health Check',
  questions: [
    {
      id: 'q1',
      type: 'choice',
      prompt: 'What best describes your business?',
      options: [
        'Labour hire or staffing',
        'Logistics, warehouse or container services',
        'Trade subcontractor or contractor',
        'Cleaning, security or facilities',
        'Other service business'
      ]
    },
    {
      id: 'q2',
      type: 'choice',
      prompt: 'How many people are paid from timesheets or rosters?',
      options: ['Under 5', '5 to 15', '16 to 30', 'More than 30']
    },
    {
      id: 'q3',
      type: 'choice',
      prompt: 'How do timesheets reach you today?',
      options: [
        'Paper, text messages or phone calls',
        'An admin person types them into a spreadsheet',
        'Google Forms or Cognito Forms feeding a spreadsheet',
        'Dedicated timesheet or rostering software'
      ]
    },
    {
      id: 'q4',
      type: 'choice',
      prompt: 'How do you turn timesheets into pay and client invoices?',
      options: [
        'Manually, with Excel or Google Sheets',
        'A spreadsheet with formulas',
        'We re-enter the numbers into Xero or MYOB',
        'It is mostly automated'
      ]
    },
    {
      id: 'q5',
      type: 'choice',
      prompt: 'How often do pay or invoice mistakes happen?',
      options: [
        'Often, and we usually find out after paying or invoicing',
        'I am not sure we would notice',
        'Occasionally',
        'Never that I know of'
      ]
    },
    {
      id: 'q6',
      type: 'choice',
      prompt: 'What is your biggest headache right now?',
      options: [
        'I cannot see profit by client, site or job',
        'Reports and invoices are hard to change',
        'The spreadsheet is slow, heavy or fragile',
        'Admin takes too much of my time',
        'No major headaches'
      ]
    },
    {
      id: 'q7',
      type: 'choice',
      prompt: 'If you decided to fix this properly, what would you most likely do?',
      options: [
        'Hire another admin person',
        'Buy software off the shelf and adapt our process to it',
        'Get a system built around how we work',
        'Just exploring, no plans yet',
        'Not sure yet'
      ]
    },
    {
      id: 'q8',
      type: 'number',
      prompt: 'Roughly how many hours a week do you or your team spend on timesheets, pay checks and invoicing?',
      min: 0,
      max: 200,
      step: 1,
      quickPicks: [2, 5, 10, 20]
    },
    {
      id: 'q9',
      type: 'number',
      prompt: 'What is the average hourly cost of the person doing that work?',
      min: 0,
      max: 300,
      step: 1,
      prefix: '$',
      suffix: 'AUD',
      helper: 'Include wages and on-costs, or what your own time is worth.',
      quickPicks: [35, 50, 75, 100]
    }
  ]
};